import {useState, useCallback, useRef, useEffect} from 'react'
import {t} from '@eitje/bridge'
import {Icon, Layout} from '~/components'

const iconSize = 16

export const SearchInput = ({onChange, onClear, value, onBlur, onKeyDown, height, placeholder = t('search')}) => {
	const inputRef = useRef(null)

	const [hasFocus, setHasFocus] = useState()

	const handleFocus = useCallback(() => setHasFocus(true), [])
	const handleBlur = useCallback(e => {
		setHasFocus(false)
		onBlur?.(e)
	}, [])

	useEffect(() => {
		if (inputRef.current) inputRef.current.focus()
	}, [])

	const isActive = hasFocus || value

	return (
		<Layout className="search-input" active={isActive} height={height} colorSet="grey-bordered" hasHover border borderRadius grow>
			<Icon name="magnifying-glass" size={iconSize} />
			<input
				ref={inputRef}
				onChange={onChange}
				onBlur={handleBlur}
				onFocus={handleFocus}
				onKeyDown={onKeyDown}
				autoComplete="off"
				name="search"
				value={value || ''}
				placeholder={placeholder}
			/>
			{value && <Icon onClick={onClear} name="cross-circled" size={iconSize} />}
		</Layout>
	)
}
